import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material"
import type { ContactListFormData } from "@crm-src/lib/contact-lists-api"

interface CreateGroupDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  formData: ContactListFormData
  onFormDataChange: (data: ContactListFormData) => void
  onSubmit: () => void
}

export function CreateGroupDialog({
  open,
  onOpenChange,
  formData,
  onFormDataChange,
  onSubmit,
}: CreateGroupDialogProps) {
  return (
    <Dialog open={open} onClose={() => onOpenChange(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Create Contact Group</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Create a new group to organize your contacts
        </DialogContentText>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, py: 2 }}>
          <TextField
            id="name"
            label="Name *"
            size="small"
            fullWidth
            value={formData.name}
            onChange={(e) => onFormDataChange({ ...formData, name: e.target.value })}
            placeholder="e.g., VIP Customers, Newsletter Subscribers"
          />
          <TextField
            id="description"
            label="Description"
            size="small"
            fullWidth
            multiline
            minRows={3}
            value={formData.description}
            onChange={(e) => onFormDataChange({ ...formData, description: e.target.value })}
            placeholder="Optional description for this group"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSubmit}>Create Group</Button>
      </DialogActions>
    </Dialog>
  )
}
